import styled from "styled-components/macro";
import { Heading1, Heading2 } from "styles/elements/Headings";
import { Paragraph } from "styles/elements/Texts";
import type { ElearningTheme } from "themes/elearning.theme";

interface Props {
  theme: ElearningTheme;
}

export const StyleLeftColumn = styled.div<Props>`
  padding: 40px 40px 0px 40px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: space-between;
  justify-content: space-between;
`;

export const StyleBookTitle = styled(Heading2)<Props>`
  margin-bottom: 60px;
`;
export const StyleTitle = styled(Heading1)<Props>``;

export const StyleContent = styled.div<Props>`
  margin-left: 50px;
  margin-top: -150px;
`;

export const StyleImgContainer = styled.div<Props>`
  position: absolute;
  top: 200px;
  right: 0;
  svg {
    height: 450px !important;
  }
`;
export const StyledStudiemeister = styled.img<Props>`
  width: 200px;
`;

export const StyleStep = styled(Paragraph)<Props>`
max-width: 500px;
line-height: 22px;
margin-top: 25px;
span {
  font-family: ${(props: Props) => props.theme.font.family.text.bold};
  margin-right: 25px;
}
&:last-of-type {
  margin-bottom: 30px;
}
`;

export const StyleParagraph = styled(Paragraph)<Props>`
  max-width: 500px;
  line-height: 22px;
`;

export const StyleSignInContainer = styled.div<Props>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 100vh;
  position: relative;
`;
